import { Backdrop, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import lang from "../i18n/lang";

interface SuccessOverlayProps {
  open: boolean;
  message?: string;
}

const SuccessOverlay = ({ open, message }: SuccessOverlayProps) => {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: 9999,
        backgroundColor: "#4caf50",
        color: "#fff",
        flexDirection: "column",
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 120, mb: 2 }} />
      <Typography variant="h4" sx={{ fontWeight: "bold", textAlign: "center" }}>
        {lang("scan.success")}
      </Typography>
      {message && (
        <Typography
          variant="h6"
          sx={{ mt: 2, textAlign: "center", maxWidth: "80%" }}
        >
          {message}
        </Typography>
      )}
    </Backdrop>
  );
};

export default SuccessOverlay;
